import { SVGProps } from 'react';

const TrendingUpDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14.828 14.828 21 21m-5 0h5v-5m0-13-9 9-4-4-6 6M16 3h5v5"
    />
  </svg>
);
export default TrendingUpDown;
